import { Container, Typography, Box, Grid, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import ModernFooter from '../Components/ModernFooter';
import ModernCard from '../Components/ModernCard';

import {
  Construction,
  Engineering,
  Architecture,
} from '@mui/icons-material';

import {
  fadeInUp,
  staggerChildren,
  staggerItem,
} from '../styles/animations';

import ServicesDate from "../Data/Services.json";
import zero from '../african-american-worker-standing-uniform-wearing-safety-hat-factory.jpg'
import un from '../steel-bar-site-construction.jpg'
import deux from '../construction-engineer.jpg'

interface Props { }

function Services(props: Props) {
    const { t, i18n } = useTranslation();
    const theme = useTheme();

    const serviceIcons = [
        <Construction />,
        <Engineering />,
        <Architecture />,
    ];

    const serviceImages = [
        zero,
        un,
        deux,
    ];

    return (
        <Box sx={{ backgroundColor: theme.palette.background.default, minHeight: '100vh' }}>
            {/* Hero Section */}
            <Box 
                sx={{
                    background: 'linear-gradient(135deg, #003d7a 0%, #1e5ba8 50%, #ff6b35 100%)',
                    color: 'white',
                    py: 8,
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <Container maxWidth="lg">
                    <motion.div
                        variants={fadeInUp}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Typography
                            variant="h3"
                            component="h1"
                            align="center"
                            gutterBottom
                            sx={{ fontWeight: 700, mb: 3 }}
                        >
                            {t("contenu.texte23")}
                        </Typography>
                        <Typography
                            variant="h6"
                            align="center"
                            sx={{ opacity: 0.9, maxWidth: 800, mx: 'auto' }}
                        >
                            NKH Construction : Vos experts en BTP
                        </Typography>
                        <Typography
                            variant="body1"
                            align="center"
                            sx={{ opacity: 0.8, maxWidth: 600, mx: 'auto', mt: 2 }}
                        >
                            Nous proposons une large gamme de services adaptés à vos besoins.
                        </Typography>
                    </motion.div>
                </Container>
            </Box>

            {/* Services Content */}
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <motion.div
                    variants={staggerChildren}
                    initial="initial"
                    whileInView="animate"
                    viewport={{ once: true, amount: 0.3 }}
                >
                    <Grid container spacing={4}>
                        {ServicesDate.map((service, index) => (
                            <Grid item xs={12} md={4} key={index}>
                                <motion.div variants={staggerItem}>
                                    <ModernCard
                                        variant="service"
                                        image={serviceImages[index]}
                                        title={service.title.split("|")[i18n.language.toLowerCase() === "fr" ? 0 : 1]}
                                        description={service.provider.split("|")[i18n.language.toLowerCase() === "fr" ? 0 : 1]}
                                        icon={serviceIcons[index]}
                                        link="/contact"
                                        linkText="En savoir plus"
                                    />
                                </motion.div>
                            </Grid>
                        ))}
                    </Grid>
                </motion.div>
            </Container>
            
            <ModernFooter />
        </Box>
    )
}

export default Services